import { createApi } from "@reduxjs/toolkit/query/react"
import { UpdateUserDto, UserDto, UsersDto } from "@custom-types/user"
import { authQuery } from "./authQuery"

export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: authQuery,
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    getUsers: builder.query<UsersDto, void>({
      query: () => ({
        url: "/users",
      }),
      providesTags: ["Users"],
    }),
    getUserByKey: builder.query<UserDto, string>({
      query: (key) => ({
        url: `/users/${key}`,
      }),
    }),
    createUser: builder.mutation<UserDto, UserDto>({
      query: (body) => ({
        url: "/users",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Users"],
    }),
    deleteUser: builder.mutation<string, string>({
      query: (key) => ({
        url: `/users/${key}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Users"],
    }),
    updateUser: builder.mutation<UserDto, { body: UpdateUserDto; key: string }>({
      query: (data) => ({
        url: `/users/${data.key}`,
        method: "PUT",
        body: data.body,
      }),
      invalidatesTags: ["Users"],
    }),
  }),
})

export const {
  useGetUsersQuery,
  useLazyGetUserByKeyQuery,
  useCreateUserMutation,
  useDeleteUserMutation,
  useUpdateUserMutation,
} = usersApi
